<template>
  <div class="haishang">
    <div style="width: 48%">
      <img class="bg_img" />
    </div>
    <div class="haishangn_right" style="width: 50%">
      <div class="haishangn_k">
        <div class="top">
          <div class="title">
            <img src="../../assets/image/patten_tou.png" alt />
            <div>藏馆精品</div>
          </div>
          <div class="more" style="cursor: pointer" @click="toMore()">
            查看更多
          </div>
        </div>
        <div class="bottom">
          <div class="bottom_k">
            <div
              style="cursor: pointer"
              class="layer_k img1"
              @click="todiancang(ciqi[0].id, 1)"
              :style="{
                backgroundImage: `url('${ciqi[0].thumb}')`,
              }"
            >
              <div class="layer">
                <p>{{ ciqi[0].title }}</p>
              </div>
            </div>
            <div class="right">
              <div
                class="gq-img-k img2"
                @click="todiancang(yuqi[0].id, 2)"
                :style="{
                  backgroundImage: `url('${yuqi[0].thumb}')`,
                }"
              ></div>
              <div
                class="gq-img-k img3"
                @click="todiancang(shufa[0].id, 3)"
                :style="{
                  backgroundImage: `url('${shufa[0].thumb}')`,
                }"
              ></div>
            </div>
          </div>
          <div class="bottom_k2">
            <div>
              <img
                @click="todiancang(guji[0].id, 4)"
                :style="{
                  backgroundImage: `url('${guji[0].thumb}')`,
                }"
                class="img4"
                alt
              />
            </div>
            <div>
              <img
                @click="todiancang(biaoben[0].id, 5)"
                :style="{
                  backgroundImage: `url('${biaoben[0].thumb}')`,
                }"
                class="img5"
                alt
              />
            </div>
            <div>
              <img
                @click="todiancang(qita[0].id, 6)"
                :style="{
                  backgroundImage: `url('${qita[0].thumb}')`,
                }"
                class="img6"
                alt
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      orderId: "",
      img: [],
      ciqi: [{}],
      guji: [{}],
      biaoben: [{}],
      shufa: [{}],
      yuqi: [{}],
      qita: [{}],
    };
  },
  created() {
    this.getCollection();
  },
  methods: {
    getCollection() {
      this.$api.get(`${this.book}man/show`).then((res) => {
        this.ciqi = res.data.ciqi;
        this.shufa = res.data.shufa;
        this.biaoben = res.data.biaoben;
        this.guji = res.data.guji;
        this.yuqi = res.data.yuqi;
        this.qita = res.data.qita;
      });
    },
    toMore() {
      this.$router
        .push({
          path: "/cangpinjiansuo/cangpinjiansuo2/:id",
          query: {
            orderId: 1,

            sort: "8a7aef0958b37e280158b38d781e0033",
          },
        })
        .catch((err) => {
          err;
        });
    },
    todiancang(id, index) {
      this.$router
        .push({
          path: `/cangpinjiansuo/cangpinjiansuodetail?id=${id}`,
          query: {
            orderId: index,
          },
        })
        .catch((err) => {
          err;
        });
    },
    moveover() {
      // this.move.transform='scale(1)'
    },
  },
};
</script>
<style scoped>
.img1 {
  width: 100%;

  min-height: 268px;
  cursor: pointer;
  /* background-image: url("../../assets/image/ciqi.png"); */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-right: 20px;
}
.img2,
.img3 {
  width: 230px;
  height: 100%;
  min-height: 180px;
  cursor: pointer;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.img3 {
  background-image: url("../../assets/image/shuhua.png");
}
.img4,
.img5,
.img6 {
  width: 100%;

  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  cursor: pointer;
}

.gq-img-k {
  height: 50%;
  cursor: pointer;
}
.haishang {
  display: flex;
  width: 100%;
  height: calc(100vh - 149px);
  box-sizing: border-box;
}
.haishangn_right {
  background: rgb(181, 171, 139);
  display: flex;
  height: 80vh;
  height: calc(100vh - 100px);
  overflow: hidden;
  justify-items: center;
}
.haishangn_k {
  margin: auto;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px 15px 30px;
}
.haishangn_k .top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: auto;
  margin-bottom: 20px;
  padding-top: 20px;
  width: 85%;
}
.haishangn_k .top .title img {
  margin-right: 10px;
}
.haishangn_k .top .title {
  display: flex;
  color: white;
  font-size: 30px;
}
.haishangn_k .top .more {
  color: white;
}
.haishangn_k .right {
  justify-content: space-around;
  display: flex;
  flex-direction: column;

  height: 100%;
}
.haishangn_k .right > div:first-child {
  margin-bottom: 10px;
}
/* 上半文物的高和kuan */
.haishangn_k .bottom_k {
  display: flex;
  justify-content: space-between;
  width: 85%;
  margin: auto;
  min-height: 50%;

  margin-bottom: 15px;
}
/* 第一张图的宽 */
.haishangn_k .bottom_k .layer_k {
  position: relative;
  width: 60%;
}

.haishangn_k .bottom_k .layer {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  color: white;
  font-size: 18px;
  box-sizing: border-box;
  background-color: rgba(25, 25, 25, 0.5);
  padding: 0 15px;
}

.haishangn_k .bottom {
  width: 100%;
  height: 85%;
}
.haishangn_k .bottom_k2 > div {
  width: 29%;
  height: 100%;
}
.haishangn_k .bottom_k2 {
  display: flex;
  height: 25%;

  width: 85%;
  margin: auto;
  justify-content: space-between;
}
.haishang .bg_img {
  /* background-position: center; */

  background-image: url("../../assets/image/haishang.png");
  width: 100%;
  height: 100%;
  margin-left: 2%;
  background-size: cover;
}
@media only screen and (min-width: 1600px) {
  .haishangn_k .top {
    margin-bottom: 30px;
    padding-top: 30px;
  }
  .img1 {
    width: 425px;
    height: 380px;
  }
  .img2,
  .img3 {
    width: 300px;
    height: 160px;
  }
  .img4,
  .img5,
  .img6 {
    width: 230px;
    height: 200px;
    margin-right: 0px;
  }
  .haishangn_k .bottom_k {
    display: flex;
    justify-content: space-between;
    width: 85%;
    margin: auto;
    min-height: 50%;

    margin-bottom: 60px;
  }
  .haishangn_k .bottom {
    height: 80%;
  }

  .haishangn_k .bottom_k .layer {
    width: 100%;
    height: 60px;
    font-size: 16px;
    bottom: 0px;
  }
}
@media only screen and (min-width: 1400px) and (max-width: 1600px) {
  .haishangn_k .top {
    margin-bottom: 10px;
    padding-top: 15px;
  }
  .img1 {
    width: 425px;
    height: 365px;
  }
  .img2,
  .img3 {
    width: 300px;
    height: 130px;
  }
  .img4,
  .img5,
  .img6 {
    width: 180px;
    height: 110px;
    margin-right: 0px;
  }
  .haishangn_k .bottom_k {
    margin-bottom: 15px;
  }
}
@media only screen and (min-width: 1366px) and (max-width: 1400px) {
  .img1 {
    width: 425px;
    height: 380px;
  }
  .img2,
  .img3 {
    width: 300px;
    height: 160px;
  }
  .img4,
  .img5,
  .img6 {
    width: 170px;
    height: 120px;
    margin-right: 0px;
  }
  .haishangn_k .bottom_k {
    display: flex;
    justify-content: space-between;
    width: 85%;
    margin: auto;
    min-height: 50%;

    margin-bottom: 45px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1366px) {
  .img1 {
    width: 100%;
    height: 100%;
    min-height: 268px;
    cursor: pointer;
    /* background-image: url("../../assets/image/ciqi.png"); */
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-right: 20px;
  }
  .img2,
  .img3 {
    min-width: 224px;
    height: 100%;
    min-height: 127px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  .img3 {
    background-image: url("../../assets/image/shuhua.png");
  }
  .img4,
  .img5,
  .img6 {
    width: 100%;

    height: 100px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;

    cursor: pointer;
  }
  .haishangn_k .bottom {
    width: 100%;
    height: 85%;
  }
  .haishangn_k .bottom_k2 > div {
    width: 30%;
    height: 90%;
  }
  .haishangn_k .bottom_k2 {
    display: flex;
    height: 24%;

    width: 90%;
    margin: auto;
    justify-content: space-between;
  }
  /* 上半文物的高和kuan */
  .haishangn_k .bottom_k {
    display: flex;
    justify-content: space-between;
    width: 90%;
    margin: auto;
    /* min-height: 50%; */

    margin-bottom: 35px;
  }
  .haishangn_k .top {
    width: 97%;
  }
}

/* @media only screen and (min-width: 1111px) and (max-width: 1280px) {
  .img1 {
    width: 355px;
    height: 350px;
    margin-right: 20px;
  }
  .img2,
  .img3 {
    width: 190px;
    height: 149px;
  }
  .img4,
  .img5,
  .img6 {
    width: 182px;
    height: 130px;
    margin-right: 10px;
  }
  .haishangn_k .bottom {
    height: 90%;
  }
  .haishangn_k .bottom_k {
    margin-bottom: 25px;
    height: 380px;
  }
  .haishangn_k .bottom_k .layer {
    width: 355px;
    height: 40px;

    font-size: 16px;
    bottom: 30px;
  }
  .haishangn_k .bottom_k2 {
    width: 498px;
  }
  .haishangn_k .top {
    width: 97%;
  }
} */
/* @media only screen and (min-width: 0px) and (max-width: 1024px) {
  .img1 {
    width: 250px;
    height: 200px;
    margin-right: 20px;
  }
  .img2,
  .img3 {
    width: 110px;
    height: 100px;
  }
  .img4,
  .img5,
  .img6 {
    width: 110px;
    height: 100px;
    margin-right: 10px;
  }
  .haishangn_k .bottom {
    height: 60%;
  }
  .haishangn_k .bottom_k {
    margin-bottom: 25px;
    height: 120px;
  }
  .haishangn_k .bottom_k .layer {
    width: 250px;
    height: 40px;

    font-size: 16px;
    bottom: -80px;
  }
  .haishangn_k .bottom_k2 {
    width: 380px;
  }
  .haishangn_k .top {
    width: 80%;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/index_parent/ex.vue